import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Grid } from "@material-ui/core/";
import { Colors } from "../constants";

import { mediaHelper } from "../utils";
import { OrderCategoryEnum } from "../constants/OrderCategory";

const propTypes = {
  title: PropTypes.string.isRequired,
  right: PropTypes.node,
};

const defaultProps = {
  right: undefined,
};

const translateOrderTypeTitle = (orderTypeTitle) => {
  switch (orderTypeTitle) {
    case OrderCategoryEnum.PROMOTIONAL:
      return "Promocional";
    case OrderCategoryEnum.AMOSTRA_GRATIS:
      return "Amostra grátis";
    case OrderCategoryEnum.AMOSTRA_GRATIS_TRIBUTADA:
      return "Amostra grátis tributada";
    default:
      return "--";
  }
};

const backgroundColorByType = {
  amostra_gratis: Colors.LAVANDER_LIGHT,
  amostra_gratis_tributada: Colors.BLUE_GRAY_LIGHT,
};

const colorsByType = {
  amostra_gratis: Colors.LAVANDER_DARK,
  amostra_gratis_tributada: Colors.BLUE_GRAY_DARK,
};

const TitleText = styled.h1`
  color: ${Colors.SECONDARY_MEDIUM};
  font-weight: 400;
  margin: ${({ orderTypeTitle }) => (orderTypeTitle ? "0px" : "16px 0px")};

  ${mediaHelper.md`
    margin: ${({ orderTypeTitle }) => (orderTypeTitle ? " 0px" : "32px 0px")};
  `}

  font-size: 34px;
  ${mediaHelper.lg`
    font-size: 34px;
  `};
`;

const OrderTypeTitleText = styled.span`
  color: ${({ type }) => colorsByType[type] ?? Colors.GREEN_LIGHT};
  background-color: ${({ type }) =>
    backgroundColorByType[type] ?? Colors.BLUE_VIVID_LIGHT};
  padding: 4px 10px;
  border-radius: 16px;
  width: fit-content;
  font-weight: 700;
  font-size: 12px;
`;

const TitleTextWithOrderType = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 0px;
  ${mediaHelper.md`
    margin: 32px 0px;
  `}
`;

const RightWrapper = styled.div`
  display: flex;
  margin-left: auto;
`;

const TitleWrapper = styled.div`
  overflow: hidden;
`;

const TitlePage = ({ title, smallTitle, right, orderTypeTitle }) => (
  <TitleWrapper>
    <Grid container spacing={3}>
      <Grid item lg={8} md={8} xs={12}>
        {orderTypeTitle ? (
          <TitleTextWithOrderType>
            <TitleText smallTitle={smallTitle} orderTypeTitle={orderTypeTitle}>
              {title}
            </TitleText>
            <OrderTypeTitleText type={orderTypeTitle}>
              {translateOrderTypeTitle(orderTypeTitle)}
            </OrderTypeTitleText>
          </TitleTextWithOrderType>
        ) : (
          <TitleText smallTitle={smallTitle}>{title}</TitleText>
        )}
      </Grid>
      {right && (
        <Grid item lg={4} md={4} xs={12}>
          <RightWrapper>{right}</RightWrapper>
        </Grid>
      )}
    </Grid>
  </TitleWrapper>
);

TitlePage.propTypes = propTypes;
TitlePage.defaultProps = defaultProps;

export default TitlePage;
